import { render, staticRenderFns } from "./EmailSignatureModal.vue?vue&type=template&id=b7e0ffa4&scoped=true&"
import script from "./EmailSignatureModal.vue?vue&type=script&lang=js&"
export * from "./EmailSignatureModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailSignatureModal.vue?vue&type=style&index=0&id=b7e0ffa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e0ffa4",
  null
  
)

export default component.exports